import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const AdminPrivateRoute = ({ children }) => {
	const employeeToken = Cookies.get("employeeToken");
	const employeeRole = Cookies.get("employeeRole");

	// Not logged in
	if (!employeeToken) {
		return <Navigate to="/" replace />;
	}

	// Logged in but not admin
	if (employeeRole !== "Admin Employee") {
		return <Navigate to="/Dashboard" replace />;
	}

	return children;
};

export default AdminPrivateRoute;
